import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { ConsultancyServicesComponent } from './consultancy-services/consultancy-services.component';
import { ConstructionWorkComponent } from './construction-work/construction-work.component';
import { TechnicalSubmissionComponent } from './technical-submission/technical-submission.component';
import { CommercialSubmissionComponent } from './commercial-submission/commercial-submission.component';
import { ConclusionComponent } from './conclusion/conclusion.component';

@Component({
  imports: [
    CommonModule,
    ConsultancyServicesComponent,
    ConstructionWorkComponent,
    TechnicalSubmissionComponent,
    CommercialSubmissionComponent,
    ConclusionComponent,
  ],
  standalone: true,
  selector: 'app-itt-section-dialogs',
  templateUrl: './itt-section-dialogs.component.html',
  styleUrls: ['./itt-section-dialogs.component.css'],
})
export class IttSectionDialogsComponent implements OnInit {
  @Input() submissionType: string;
  @Input() tendererResponse: any;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  currentStep = 1;
  project_name: string;
  tenderType: string;
  tendererResponseData: any = [];

  constructor(
    private TenderingService: TenderingService,
  ) {}

  ngOnInit(): void {
    this.TenderingService.tenderType$.subscribe((state) => {
      this.tenderType = state;
    });
    if (this.tendererResponse) {
      this.mapRFPExistingData();
    }
  }

  nextStep() {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.TenderingService.setEditState(true);
    }
  }

  handleCloseModal() {
    this.closeModalEvent.emit();
  }

  handleConstructionWorksEmittedData(constructionWorksData: any) {
    this.tendererResponseData['sitePreparation'] =
      constructionWorksData?.site_preparation;
    this.tendererResponseData['civilWorks'] =
      constructionWorksData?.structural_civil_works;
    this.tendererResponseData['mepWorks'] = constructionWorksData?.mep_works;
    this.tendererResponseData['fitOut'] =
      constructionWorksData?.finishing_fitout;
    this.tendererResponseData['healthSafety'] =
      constructionWorksData?.health_safety_compliance;
    this.tendererResponseData['postConstruction'] =
      constructionWorksData?.post_construction_activities;

    // Attachments for each field
    this.tendererResponseData['site_preparation_attach'] =
      constructionWorksData?.site_preparation_attach;
    this.tendererResponseData['structure_civil_attach'] =
      constructionWorksData?.structure_civil_attach;
    this.tendererResponseData['mep_work_attach'] =
      constructionWorksData?.mep_work_attach;
    this.tendererResponseData['finishing_fitout_attach'] =
      constructionWorksData?.finishing_fitout_attach;
    this.tendererResponseData['health_safety_attach'] =
      constructionWorksData?.health_safety_attach;
    this.tendererResponseData['post_construction_attach'] =
      constructionWorksData?.post_construction_attach;
  }

  handleConsultancyServiceEmittedData(constructionWorksData: any) {
    this.tendererResponseData['projectManagement'] =
      constructionWorksData?.project_management;
    this.tendererResponseData['designServices'] =
      constructionWorksData?.design_services;
    this.tendererResponseData['costConsultancy'] =
      constructionWorksData?.cost_consultancy;
    this.tendererResponseData['contractAdministration'] =
      constructionWorksData?.contract_administration;
    this.tendererResponseData['riskManagement'] =
      constructionWorksData?.risk_management;
    this.tendererResponseData['sustainabilityCompliance'] =
      constructionWorksData?.sustainability_compliance;
    this.tendererResponseData['finalSustainabilityCompliance'] =
      constructionWorksData?.final_sustainability_compliance;
  }

  handleTechnicalSubmissionEmittedData(technicalSubmissionData: any) {
    this.tendererResponseData['hasEnvironmentalPlan'] =
      Number(technicalSubmissionData?.has_environmental_plan) || 0;
    this.tendererResponseData['environmentalPlanDescription'] =
      technicalSubmissionData?.environmental_plan_description;
    this.tendererResponseData['hasTechnicalDeviations'] =
      Number(technicalSubmissionData?.has_technical_deviations) || 0;
    this.tendererResponseData['technicalDeviationsDescription'] =
      technicalSubmissionData?.technical_deviations_description;
    this.tendererResponseData['projectProgramme'] =
      technicalSubmissionData?.project_programme;
    this.tendererResponseData['healthSafetyPlan'] =
      technicalSubmissionData?.health_safety_plan;
    this.tendererResponseData['technicalProposal'] =
      technicalSubmissionData?.technical_proposal;
      this.tendererResponseData['relevantExperience'] = JSON.parse(
        technicalSubmissionData.relevant_experience
      );
   

    this.tendererResponseData['cvsOfKeyPersonnelsAttachments'] =
      technicalSubmissionData?.cvs_of_key_personnel_attach;
    this.tendererResponseData['technicalProposalAttachments'] =
      technicalSubmissionData?.technical_proposal_attach;
    this.tendererResponseData['technicalHealthSafetyAttachments'] =
      technicalSubmissionData?.technical_health_safety_attach;
    this.tendererResponseData['relevantExperienceAttachments'] =
      technicalSubmissionData?.relevant_experience_attach;
    this.tendererResponseData['projectProgrammeAttachments'] =
      technicalSubmissionData?.project_programme_attach;

  }

  handleCommercialSubmissionEmittedData(commercialSubmissionData: any) {
    this.tendererResponseData['priceBreakdownTitle'] =
      commercialSubmissionData?.price_breakdown_title;
    this.tendererResponseData['priceBreakdownDescription'] =
      commercialSubmissionData?.price_breakdown_description;
    this.tendererResponseData['financialStabilityDescription'] =
      commercialSubmissionData?.financial_stability_description;
    this.tendererResponseData['contractualComments'] =
      commercialSubmissionData?.contractual_comments;

    this.tendererResponseData['commercialPriceBreakdownAttachments'] =
      commercialSubmissionData?.commercial_price_breakdown_attach;
    this.tendererResponseData['performanceBondGuaranteeAttachments'] =
      commercialSubmissionData?.performance_bond_gurantee_attach;
    this.tendererResponseData['financialStabilityAttachments'] =
      commercialSubmissionData?.financial_stability_attach;
    this.tendererResponseData['proofOfInsuranceAttachments'] =
      commercialSubmissionData?.proof_of_insurance_attach;
  }

  handleConclusionSubmissionEmittedData(conclusionSubmissionData: any) {
    this.tendererResponseData['tendererCompanyName'] =
      conclusionSubmissionData?.tenderer_company_name;
    this.tendererResponseData['tendererContactInformation'] =
      conclusionSubmissionData?.tenderer_contact_information;
    this.tendererResponseData['tendererName'] =
      conclusionSubmissionData?.tenderer_name;
    this.tendererResponseData['tendererPosition'] =
      conclusionSubmissionData?.tenderer_position;
  }

  mapRFPExistingData() {
    this.handleConstructionWorksEmittedData(this.tendererResponse);
    this.handleConsultancyServiceEmittedData(this.tendererResponse);
    this.handleTechnicalSubmissionEmittedData(this.tendererResponse);
    this.handleCommercialSubmissionEmittedData(this.tendererResponse);
    this.handleConclusionSubmissionEmittedData(this.tendererResponse);
    // this.calculateCurrentStep();
  }


  /**
   * NOTE: dont need it now
   * This function is faulty. If uncommented, will need fixing
   */
  // calculateCurrentStep() {
  //   // Check if all required data is available and assign values conditionally
  //   if (this.tenderType === 'consultancy services' &&  !this.tendererResponse?.project_management &&
  //       !this.tendererResponse?.design_services &&
  //       !this.tendererResponse?.cost_consultancy &&
  //       !this.tendererResponse?.contract_administration &&
  //       !this.tendererResponse?.risk_management &&
  //       !this.tendererResponse?.sustainability_compliance &&
  //       !this.tendererResponse?.final_sustainability_compliance) {
  //       this.currentStep = 1;
  //   } else if (this.tenderType === 'construction works' &&  !this.tendererResponse?.site_preparation &&
  //       !this.tendererResponse?.structural_civil_works &&
  //       !this.tendererResponse?.mep_works &&
  //       !this.tendererResponse?.finishing_fitout &&
  //       !this.tendererResponse?.health_safety_compliance &&
  //       !this.tendererResponse?.post_construction_activities &&
  //       !this.tendererResponse?.site_preparation_attachments &&
  //       !this.tendererResponse?.health_safety_attachments &&
  //       !this.tendererResponse?.structure_civil_attachments) {
  //       this.currentStep = 1;
  //   } else if (!this.tendererResponse?.technical_proposal) {
  //      this.currentStep = 2;
  //   } else if (!this.tendererResponse?.price_breakdown_title) {
  //     this.currentStep = 3;
  //   } else if (
  //     !this.tendererResponse?.tenderer_name &&
  //     !this.tendererResponse?.tenderer_position
  //   ) {
  //     this.currentStep = 4;
  //   } else {
  //      this.currentStep = 1;
  //   }
  // }

}
